import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Layout from './Layout';

const client = new QueryClient();

const Nav = ({ activeItem }) => {
  return (
    <QueryClientProvider client={client}>
      <Layout activeItem={activeItem} />
    </QueryClientProvider>
  );
};

export default Nav;
